module.exports = require("@wordpress/deprecated");